export class FirebaseErrors {
  static Parse(errorCode: string): string {
    let message: string;

    switch (errorCode) {
      case 'auth/wrong-password':
        message = 'E-mail ou senha incorreto(a)';
        break;
      case 'auth/network-request-failed':
        message = 'Verifique sua conexão com a internet';
        break;
      case 'auth/too-many-requests':
        message = 'Muitas tentativas, tente novamente mais tarde!';
        break;
      case 'auth/user-disabled':
        message =
          'Sua conta foi desativada ou excluída, por favor contate o administrador do sistema';
        break;
      case 'auth/requires-recent-login':
        message = 'Faça o login novamente!';
        break;
      case 'auth/email-already-exists':
        message = 'O endereço de e-mail já está sendo usado por um usuário existente.';
        break;
      case 'auth/user-not-found':
        message = 'Não foi possível encontrar a conta do usuário associada ao endereço de e-mail';
        break;
      case 'auth/phone-number-already-exists':
        message = 'O número de telefone já está sendo usado por um usuário existente.';
        break;
      case 'auth/invalid-phone-number':
        message = 'O número de telefone não é válido!';
        break;
      case 'auth/invalid-email  ':
        message = 'O endereço de e-mail não é válido!';
        break;
      case 'auth/cannot-delete-own-user-account':
        message = 'Você não pode deletar sua própria conta de usuário.';
        break;
      case 'auth/weak-password':
        message = 'A senha deve ter pelo menos 6 caracteres.';
        break;
      case 'auth/popup-blocked':
        message = 'Popup bloqueado pelo navegador. Por favor, habilite o popup e tente novamente';
        break;
      default:
        message = 'Ops! Algo deu errado. Tente mais tarde.';
        break;
    }

    return message;
  }
}
